export default __webpack_public_path__ + "c3f339237111542373bf42aada892b73.png";